module.exports = __webpack_public_path__ + "static/media/restart-icon.2c96382f.svg";